package com.essntl.features.task.ui.sharedtask

import androidx.compose.runtime.Composable
import com.essntl.features.itinerary.domain.model.ItineraryModel
import com.essntl.uikit.rememberContains

@Composable
fun SharedTaskState.rememberItinerary(
    itineraryId: String?,
    serviceItineraryId: String?,
): ItineraryModel? {
    return rememberContains(
        getAllItineraries.data.orEmpty(),
        setOf(itineraryId, serviceItineraryId),
    ) { itinerary -> itinerary.id }.firstOrNull()
}